import { TableList } from 'seagull/components/TableList';
import { Typography } from 'seagull/components/Typography';
import { utils } from "../../../../../utils";
import { displayLineItemRate } from "../ScheduledInvoice.utils";
import styles from "./SubLineItem.module.scss";
import { emptyCell } from "../../../../../constants";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function SubLineItemRow(rowProps) {
  const {
    subLineItem,
    testid,
    disableMarginBottom,
    quantity
  } = rowProps;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(TableList.Row, {
      "data-testid": testid,
      addPulse: false,
      disableMarginBottom: true,
      size: "small",
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          className: styles.name,
          variant: "paragraph2",
          ellipsis: true,
          "data-testid": "".concat(testid, "-name"),
          children: subLineItem.name
        })
      }, {
        value: quantity ? /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "disabled",
          "data-testid": "".concat(testid, "-quantity"),
          children: utils.formatNumberWithCommas(quantity)
        }) : null
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "disabled",
          ellipsis: true,
          "data-testid": "".concat(testid, "-rate"),
          children: displayLineItemRate(subLineItem.rate)
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "disabled",
          "data-testid": "".concat(testid, "-discount"),
          children: subLineItem.discount ? subLineItem.discount.format() : ''
        })
      }, {
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "disabled",
          "data-testid": "".concat(testid, "-total"),
          children: utils.formatDollarAmount(subLineItem.totalAmount)
        })
      }, emptyCell, emptyCell]
    }), /*#__PURE__*/_jsx(TableList.Row, {
      "data-testid": "".concat(testid, "-note"),
      size: "fluid",
      className: styles.gapBottom,
      disableMarginBottom: disableMarginBottom,
      items: [{
        value: /*#__PURE__*/_jsx(Typography, {
          variant: "paragraph2",
          skin: "secondary",
          breakWords: true,
          className: styles.name,
          children: "hidden from your client"
        })
      }, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell, emptyCell]
    })]
  });
}